import React, {useContext} from "react"
import {Panel, DataRow} from "../../PDFPrimitives"
import {PDFContext} from "../../BasePDF"

export const PurchaseCustomerPaymentInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Payment Information">
            <DataRow
                label="Cash Due on Delivery"
                value={pdfData.cash_due_on_delivery.toDollarFormat()}
            />
            <DataRow
                label="Payment"
                value={pdfData.monthly_payment.toDollarFormat()}
                variant="blue"
            />
            <DataRow label="Annual Percentage Rate (APR)" value={`${pdfData.apr}%`}/>
            <DataRow label="Term" value={String(pdfData.term)} isLast/>
        </Panel>
    )
}
